import axios from 'axios'
import store from '@/store/store'
import router from '@/router/router'

// Get values from environment variables
const rootApiUrl = process.env.VUE_APP_ROOT_API
const apiKey = process.env.VUE_APP_API_KEY
const token = ''

/**
 * Create instance for calls using an authorization token and set config defaults
 */
const tokenInstance = axios.create({
  baseURL: rootApiUrl,
  headers: {
    Authorization: `Bearer: ${token}`
  }
})

// Intercept responses, check for errors and return only the data object
tokenInstance.interceptors.response.use(
  (response) => {
    if (response.data.success) {
      return response.data
    } else {
      return Promise.reject(response.data)
    }
  },
  (error) => {
    if (typeof (error.response) === 'undefined') {
      return Promise.reject(new Error('Error connecting to API server'))
    } else {
      // If we get an unauthorized response (401), then we logout and redirect to login page
      if (error.response.status === 401) {
        localStorage.removeItem('user-token')
        store.commit('AUTH_LOGOUT')
        router.push('/')
      }
      return Promise.reject(error.response.data)
    }
  }
)

/**
 * Create instance for calls using apiKey and set config defaults
 */
const apiKeyInstance = axios.create({
  baseURL: rootApiUrl,
  params: {
    apiKey: apiKey
  }
})

// Intercept responses, check for errors and return only the data object
apiKeyInstance.interceptors.response.use(
  (response) => {
    if (response.data.success) {
      return response.data
    } else {
      return Promise.reject(response.data)
    }
  },
  (error) => {
    if (typeof (error.response) === 'undefined') {
      return Promise.reject(new Error('Error connecting to API server'))
    } else {
      return Promise.reject(error.response.data)
    }
  }
)

export default {
  uploadImagesWithToken: ({ url, method, data }) => new Promise((resolve, reject) => {
    try {
      // Set the auth token before calling the API
      let token = store.getters.token
      tokenInstance.defaults.headers.Authorization = `Bearer ${token}`

      // Make the API call with auth token
      tokenInstance({
        url: url,
        method: method,
        data: data,
        config: {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        },
        onUploadProgress: (progressEvent) => {
          store.commit('UPLOAD_PROGRESS_UPDATE', parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total)))
        }
      })
        // If successful, resolve Promise with response data
        .then(response => {
          resolve(response)
        })
        // If error, reject Promise with error
        .catch(err => {
          reject(err)
        })
    } catch (err) {
      reject(err)
    }
  }),

  // Function to call with auth token
  callWithToken: ({ url, method, data }) => new Promise((resolve, reject) => {
    try {
      // Set the auth token before calling the API
      let token = store.getters.token
      tokenInstance.defaults.headers.Authorization = `Bearer ${token}`

      // Make the API call with auth token
      tokenInstance({
        url: url,
        method: method,
        data: data
      })
        // If successful, resolve Promise with response data
        .then(response => {
          resolve(response)
        })
        // If error, reject Promise with error
        .catch(err => {
          reject(err)
        })
    } catch (err) {
      reject(err)
    }
  }),

  // Function to call with API key
  callWithKey: ({ url, method, data }) => new Promise((resolve, reject) => {
    try {
      // Make the API call with API key
      apiKeyInstance({
        url: url,
        method: method,
        data: data
      })
        // If successful, resolve Promise with response data
        .then(response => {
          resolve(response)
        })
        // If error, reject Promise with error
        .catch(err => {
          reject(err)
        })
    } catch (err) {
      reject(err)
    }
  }),

  // Animation helper when data is loaded to a data-table from an API
  animateTableHeight: () => {
    setTimeout(() => {
      let setHeight = 0
      document.querySelectorAll('#data-table table').forEach((element) => {
        setHeight += element.offsetHeight
      })

      document.getElementById('data-table').style.height = setHeight + 'px'
    }, 100)
    // Set height to auto (bug with small height difference, when table's horizontal scrollbar is visible)
    setTimeout(() => {
      document.getElementById('data-table').style.height = 'auto'
    }, 300)
  }
}
